import * as STORAGE from '@/constants/STORAGE';

import { apiSetToken } from '@/services/api-varejoweb';

import storage from '@/services/storage';
import api from '@/services/api-varejoweb';

export default {
  namespaced: true,

  state: {
    accessToken: null,
    user: null,
  },

  getters: {
    accessToken: (state) => state.accessToken,
    user: (state) => state.user,
  },

  actions: {
    async $_setup({ dispatch, commit }) {
      const accessToken = await storage.getItem(STORAGE.TOKEN);
      if (!accessToken) return;

      if (new Date() > new Date(accessToken.expires)) {
        await storage.removeItem(STORAGE.TOKEN);
        return;
      }

      commit('SET_TOKEN', accessToken);

      await new Promise((resolve) => setTimeout(resolve, 100));
      await dispatch('loadUser');
    },

    // Adicionamos o 'dispatch' aqui para podermos chamar outras ações do Vuex
    async authenticate({ dispatch, commit }, payload) {
      try {
        // 1. Faz o login para validar se o usuário e senha estão corretos na API
        const response = await api.post('/vendedor/login', payload);
        const data = response.data.data || response.data; 
        const vendedor = data.vendedor || data.user;

        // 2. Faz a requisição na API de Empresa usando a sua própria action do empresa.js
        // Usamos { root: true } porque estamos dentro do namespaced 'auth' e queremos acessar 'empresa'
        const dadosEmpresa = await dispatch('empresa/find', {}, { root: true });
        
        // Trata a resposta: a API pode devolver um Array ou um Objeto direto
        const empresa = Array.isArray(dadosEmpresa) ? dadosEmpresa : (dadosEmpresa.data || dadosEmpresa);

        if (!empresa) {
           throw new Error('Nenhum dado de empresa retornado pela API!');
        }

        // 3. Captura a chave (com letras maiúsculas ou minúsculas por segurança)
        const tokenString = empresa.EMPChaveAppVenda || empresa.empchaveappvenda;

        if (!tokenString) {
           throw new Error('A chave EMPChaveAppVenda não foi encontrada na resposta da empresa!');
        }

        // 4. Monta o Token usando a chave da empresa
        const accessToken = { token: tokenString };

        // 5. Guarda na sessão e atualiza o estado
        await storage.setItem(STORAGE.TOKEN, accessToken);
        commit('SET_TOKEN', accessToken);
        
        commit('SET_USER', vendedor); 

      } catch (error) {
        console.error('Erro na autenticação (Vendedor ou Empresa):', error);
        throw error;
      }
    },

    async authenticateLocal() {
      const accessToken = { token: 'f60a4a79-37bf-44b3-a661-ce18eb83e6e1' };

      await storage.setItem(STORAGE.TOKENLOCAL.tokenlocal, accessToken);
    },

    async unauthenticate({ commit }) {
      await storage.removeItem(STORAGE.TOKEN);
      await storage.removeItem(STORAGE.TOKENLOCAL.tokenlocal);
      commit('SET_TOKEN', null);
      commit('SET_USER', null);
    },

    async loadUser({ commit }) {
      const user = {
        usenome: 'USUARIO',
        usechave: '@555',
      };
      commit('SET_USER', user);
    },

    // unauthenticate customizado
    async logout({ commit }) {
      await storage.removeItem(STORAGE.TOKEN);
      await storage.removeItem(STORAGE.TOKENLOCAL.tokenlocal);
      commit('SET_TOKEN', null);
      commit('SET_USER', null);
    },

  },

  mutations: {
    SET_TOKEN(state, accessToken) {
      state.accessToken = accessToken;
      apiSetToken(accessToken?.token);
    },

    SET_USER(state, user) {
      state.user = user;
    },
  },
};
